import ToDoPage from '@/components/ToDoPage'

export default {
  routes: [
    {
      path: '/',
      name: 'ToDoPage',
      component: ToDoPage
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/options.js